import { FieldValues, useController, useFormContext } from 'react-hook-form';
import { FieldProps } from '../../../../generic/FieldProps';
import { DateOfDeathInput } from '../../../BasePersonInputs/DateOfDeath/DateOfDeathInput';

export function DateOfDeathField<TValues extends FieldValues>({
  name,
  required = false,
}: FieldProps<TValues>) {
  const { control } = useFormContext<TValues>();
  const {
    field: { value, onChange },
  } = useController({
    name,
    control,
  });
  return (
    <DateOfDeathInput
      value={value as string}
      onChange={onChange}
      required={required}
      label='Auflösungsdatum'
    />
  );
}
